import React, { useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { fade } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${theme.palette.ivory.light}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background.ivory,

    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.palette.ivory.medium}i`
    },
    '&$focused': {
      backgroundColor: theme.palette.background.default,
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main
    }
  },
  passwordCursor: {
    cursor: 'pointer',
    userSelect: 'none'
  },
  focused: {}
}));

const PasswordInput = ({ ...rest }) => {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(false);

  const handleClickShowPassword = () => {
    setIsVisible(prev => !prev);
  };

  return (
    <TextField
      label="Password"
      type={isVisible ? 'text' : 'password'}
      name="password"
      autoComplete="password"
      fullWidth
      required
      margin="normal"
      variant="filled"
      inputProps={{
        pattern: `^(?=.*[A-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,-.\\/:;<=>?@[\\]^_\`{|}~])\\S{6,}$`,
        title:
          'The password must contain at least one upper case letter, one lower case letter, a number, a special character and must be at least 6 character'
      }}
      // eslint-disable-next-line
      InputProps={{
        classes: { root: classes.root, focused: classes.focused },
        disableUnderline: true,
        endAdornment: (
          <InputAdornment onClick={handleClickShowPassword}>
            {isVisible ? <VisibilityOffIcon color="primary" /> : <VisibilityIcon color="primary" />}
          </InputAdornment>
        )
      }}
      {...rest}
    />
  );
};

export default PasswordInput;
